<template>
        <div>
                <el-form>
                        <el-form-item :error="errorMessage" style="margin-bottom: 7px">
                                <div @click="showDialog">
                                        <el-input
                                                type="textarea"
                                                :autosize="true"
                                                readonly
                                                rows="1"
                                                :placeholder="placeholder"
                                                v-model="userNames"
                                                :disabled="disabled"
                                                
                                        ></el-input>
                                </div>
                        </el-form-item>
                </el-form>
                <el-dialog
                        title="请选择人员"
                        :visible.sync="dialogVisible"
                        append-to-body
                      
                        
                        @close="closeUserDialog"
                        width="35%"
                        >
                        <el-transfer
                                id="user-group-select-box"
                                filterable
                                target-order="push"
                                :filter-method="filterMethod"
                                filter-placeholder="请输入"
                                :titles="['未选','已选']"
                                :button-texts="['', '']"
                                v-model="value"
                                :data="data">
                        </el-transfer>

                        <div style="text-align: center; padding-top: 1rem">
                                <el-button
                                        type="primary"
                                        @click.native="submit"
                                        style="margin-right: 1rem"
                                        >
                                        提交
                                </el-button>
                                <el-button @click.native="dialogVisible = false">取消</el-button>
                        </div>
                </el-dialog>
        </div>
</template>
<script>
import {getGroupListForOrder} from "@/api/crmedical/device/taskManagement"

export default {
        props:{
                value:{
                        type:Array,
                        default(){
                                return [];
                        },
                },
                selectedValue:{
                        type:Array,
                        default(){
                                return [];
                        },
                },
                projectId:{
                        type:String,
                        default:'',
                },
                moduleType:{
                        type:String,
                        default:'',
                },
                subModuleId:{
                        type:String,
                        default:null,
                },
                placeholder:{
                        type:String,
                        default:'',
                }
        },
        data(){
                
                return{
                        userNames:'',
                        dialogVisible:false,
                        data: [],
                        filterMethod(query, item) {
                                return item.label.indexOf(query) > -1;
                        }

                } 
        },
        watch:{ 
                "moduleType"(){
                        this.reset();
                },
                "subModuleId"(){
                        this.reset();
                }
        },
        
        methods:{
                // 提交
                submit(){
                        let value = [];
                      
                        console.log(this.value)
                        this.data.forEach(ele=>{
                                console.log(ele)
                                let index = this.value.indexOf(ele.key);
                                if(index > -1){
                                        value[index] = ele.label;
                                }
                        })
                        this.userNames = value.join(" , ");
                        this.$emit("update:value",this.value);
                        this.dialogVisible = false;
                },
                reset(){
                        this.data = [];
                        this.userNames = "";
                        this.value = [];
                        this.$emit("update:value",[]);
                },
                getGroupListForOrder(userList,moduleType,subModuleId){
                        this.reset();
                        
                        getGroupListForOrder({projectId:this.projectId,moduleType:this.moduleType||moduleType,subModuleId:this.subModuleId||subModuleId}).then(res=>{
                                const data = [];
                                res.data.forEach((ele)=>{
                                        data.push({
                                                label: ele.realNameAndPhone,
                                                key: ele.id,
                                                pinyin: ele.id
                                        });   
                                })
                                this.data = data;
                                if(userList){
                                        let value = [];
                                        
                                        this.data.forEach(ele=>{
                                               
                                                let index = userList.indexOf(ele.key);
                                                if(index > -1){
                                                        value[index] = ele.label;
                                                }
                                        })
                                        this.userNames = value.join(" , ");
                                        this.value = userList;
                                        this.$emit("update:value",this.value);
                                }
                        }).catch(err=>{
                                this.data = [];
                        })
                },
                // 初始化数据
                initData(){
                        if(!this.moduleType && !this.subModuleId ){
                                this.$message({
                                        message: '请先选择 项目和工单类型',
                                        type: 'warning'
                                });
                                
                                return;
                        }
                        this.dialogVisible = true;
                        getGroupListForOrder({projectId:this.projectId,moduleType:this.moduleType,subModuleId:this.subModuleId}).then(res=>{
                                const data = [];
                                res.data.forEach((ele)=>{
                                        data.push({
                                                label: ele.realNameAndPhone,
                                                key: ele.id,
                                                pinyin: ele.id
                                        });   
                                })
                                this.data = data;
                                
                        }).catch(err=>{
                                this.data = [];
                        })
                        
                       
                        
                },
                showDialog(){
                        
                        this.initData();
                        
                }  
        }
}
</script>

<style lang="scss">
#user-group-select-box{
        .el-transfer__buttons{
                display: flex;
                align-items: center;
                
        }
        .el-transfer__button:first-child{
                margin-bottom: 0;
        }
}
</style>